export default "__VITE_ASSET__Y5VVj5Ls__"